var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map",class:_vm.mapClass},[(_vm.canShowMap)?[_vm._t("default",null,{"leaflet":_vm.leaflet,"map":_vm.map})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }